import { useEffect, useState } from "react";
import api from "../../api/api";
import Swal from "sweetalert2";
import "./PlanosPage.scss";

const PlanosPage = () => {
  const [planos, setPlanos] = useState([]);

  useEffect(() => {
    fetchPlanos();
  }, []);

  const fetchPlanos = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await api.get("/planos", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPlanos(res.data);
    } catch (err) {
      console.error("Erro ao buscar planos:", err);
    }
  };

  // Criar plano
  const handleCriarPlano = async () => {
    const { value: form } = await Swal.fire({
      title: "Novo Plano",
      html: `
        <input id="nome" class="swal2-input" placeholder="Nome do plano">
        <input id="valor" type="number" step="0.01" class="swal2-input" placeholder="Valor (R$)">
        <input id="duracao" type="number" class="swal2-input" placeholder="Duração em dias">
      `,
      focusConfirm: false,
      preConfirm: () => ({
        nome: document.getElementById("nome").value,
        valor: parseFloat(document.getElementById("valor").value),
        duracao_dias: parseInt(document.getElementById("duracao").value),
      }),
      showCancelButton: true,
      confirmButtonText: "Salvar",
    });

    if (form) {
      try {
        const token = localStorage.getItem("token");
        await api.post("/planos", form, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchPlanos();
        Swal.fire("Sucesso!", "Plano criado com sucesso.", "success");
      } catch (err) {
        console.error(err);
        Swal.fire("Erro", "Não foi possível criar plano", "error");
      }
    }
  };

  // Editar plano
  const handleEditarPlano = async (plano) => {
    const { value: form } = await Swal.fire({
      title: "Editar Plano",
      html: `
        <input id="nome" class="swal2-input" value="${plano.nome}" placeholder="Nome">
        <input id="valor" type="number" step="0.01" class="swal2-input" value="${plano.valor}" placeholder="Valor">
        <input id="duracao" type="number" class="swal2-input" value="${plano.duracao_dias}" placeholder="Duração">
      `,
      focusConfirm: false,
      preConfirm: () => ({
        nome: document.getElementById("nome").value,
        valor: parseFloat(document.getElementById("valor").value),
        duracao_dias: parseInt(document.getElementById("duracao").value),
        ativo: plano.ativo,
      }),
      showCancelButton: true,
      confirmButtonText: "Salvar",
    });

    if (form) {
      try {
        const token = localStorage.getItem("token");
        await api.put(`/planos/${plano.id}`, form, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchPlanos();
        Swal.fire("Sucesso!", "Plano atualizado com sucesso.", "success");
      } catch (err) {
        console.error(err);
        Swal.fire("Erro", "Não foi possível atualizar plano", "error");
      }
    }
  };

  // Ativar/Desativar
  const handleAtivarDesativar = async (plano) => {
    try {
      const token = localStorage.getItem("token");
      await api.put(`/planos/${plano.id}`, { ...plano, ativo: !plano.ativo }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchPlanos();
    } catch (err) {
      console.error(err);
      Swal.fire("Erro", "Falha ao atualizar status", "error");
    }
  };

  // Excluir
  const handleExcluirPlano = async (id) => {
    const confirm = await Swal.fire({
      title: "Excluir plano?",
      text: "Essa ação não pode ser desfeita.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Excluir",
    });

    if (confirm.isConfirmed) {
      try {
        const token = localStorage.getItem("token");
        await api.delete(`/planos/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        fetchPlanos();
        Swal.fire("Removido!", "Plano excluído com sucesso.", "success");
      } catch (err) {
        console.error(err);
        Swal.fire("Erro", "Não foi possível excluir plano", "error");
      }
    }
  };

  return (
    <div className="planos-page">
      <h1>Controle de Planos</h1>
      <button onClick={handleCriarPlano}>Novo Plano</button>

      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>Valor</th>
            <th>Duração (dias)</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {planos.map((p) => (
            <tr key={p.id}>
              <td>{p.id}</td>
              <td>{p.nome}</td>
              <td>R$ {parseFloat(p.valor || 0).toFixed(2)}</td>
              <td>{p.duracao_dias}</td>
              <td>{p.ativo ? "Ativo" : "Inativo"}</td>
              <td>
                <button className="btn editar" onClick={() => handleEditarPlano(p)}>Editar</button>
                <button className={`btn ${p.ativo ? "desativar" : "ativar"}`} onClick={() => handleAtivarDesativar(p)}>
                  {p.ativo ? "Desativar" : "Ativar"}
                </button>
                <button className="btn excluir" onClick={() => handleExcluirPlano(p.id)}>Excluir</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlanosPage;
